import dynamic from 'next/dynamic';

import { injectSsrInitialProps } from 'lib/landings';
import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getCouponFeaturedStoresList } from 'services/coupon';
import {
  getLandingInfo,
  getLandingOffersList,
  getLandingsList,
  getModularLandingInfo,
} from 'services/landing';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LANDINGS from 'constants/landings';
import LINKS from 'constants/links';

const Landing = dynamic(() => import('components/pages/Landing/BlackFriday'));
const ModularLanding = dynamic(() => import('components/pages/ModularLanding'));

const BLACK_FRIDAY_API_PARAM = 'black-friday';

const BlackFriday = (props) =>
  props?.isModularLanding ? (
    <ModularLanding {...props} />
  ) : (
    <Landing
      offersListProps={{ showButtonBeforeFirstPagination: true }}
      {...props}
    />
  );

export const getServerSideProps = async () => {
  try {
    const [
      { landing },
      { data: modularLanding },
      initialOffers,
      storesWithFeaturedCoupons,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getLandingInfo({ landingSlug: BLACK_FRIDAY_API_PARAM }),
      getModularLandingInfo({ landingSlug: BLACK_FRIDAY_API_PARAM }),
      getLandingOffersList({
        landingSlug: BLACK_FRIDAY_API_PARAM,
        limit: LANDINGS.OFFERS_SERVER_LIMIT,
      }),
      {
        fn: getCouponFeaturedStoresList(),
        fallback: getCouponFeaturedStoresList.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    const isModularLanding = modularLanding?.components.length > 0;

    if (
      landing.landingType !== LANDINGS.TYPES.BLACK_FRIDAY ||
      modularLanding.type !== LANDINGS.TYPES.BLACK_FRIDAY ||
      !modularLanding ||
      (!isModularLanding && !landing)
    ) {
      return { redirect: { destination: LINKS[404], permanent: false } };
    }

    const landingWithInitialProps = isModularLanding
      ? await injectSsrInitialProps(modularLanding)
      : landing;

    return {
      props: {
        initialOffers,
        isModularLanding,
        landing: landingWithInitialProps,
        storesWithFeaturedCoupons,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default BlackFriday;
